import React, { FC } from 'react'
import { TheirOfficeProps as Props } from './types'

const TheirOffice: FC<Props> = ({ strings }) => {
  return (
    <div>
      <i>{ strings.guests_can_indicate }</i>
    </div>
  )
}

export default TheirOffice